import { render, staticRenderFns } from "./activityEject.vue?vue&type=template&id=f2664736&scoped=true&"
import script from "./activityEject.vue?vue&type=script&lang=js&"
export * from "./activityEject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2664736",
  null
  
)

export default component.exports